import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=830ec1de&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"
import style0 from "./FooterPage.vue?vue&type=style&index=0&id=830ec1de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830ec1de",
  null
  
)

export default component.exports